import React, { useEffect, useState } from "react";
import axios from 'axios';
import ListaStoricoOrdini from "./ListaStoricoOrdini";

function StoricoOrdini({
  dataStart,
  dataEnd,
  token,
  apiUrl
}) {

  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(false);

  ////////////////////       FETCH INIZIALE      ///////////////////////////
  const fetchOrdini = async () => {
    setLoading(true);
    const nuoviParams = new URLSearchParams({
      dataStart: dataStart,
      dataEnd: dataEnd
    })
    const response = await axios.get(apiUrl + "/logistica/dashboard/storicoOrdini?" + nuoviParams);
    console.log(response.data)
    setLista(response.data);
    setLoading(false);      
};

useEffect(() => {
    if (!token) {
        console.warn("sto aspettando un token")
        return;
    }
    fetchOrdini()
}, [token,dataStart,dataEnd]);
//////////////////////////////////////////////////////////////////////////

  return (
    <div className="sfondoBiancoTema ma3 pa3 br4">
      <ListaStoricoOrdini lista={lista} loading={loading}/>
      {/* {!loading && <pre className='w-50'>{JSON.stringify(lista, null, 2)}</pre>} */}
    </div>
  )

}

export default StoricoOrdini;